const observed = new WeakSet();
const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');
const observer = typeof IntersectionObserver === 'function'
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ms-is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
  : null;

function initializeMobiustreamHome(scope = document) {
  const home = scope.matches?.('.ms-home')
    ? scope
    : scope.closest?.('.ms-home') || scope.querySelector?.('.ms-home');
  if (!home) return;

  const animate = !motionPreference.matches && !isDesignMode && Boolean(observer);
  home.classList.toggle('ms-motion-ready', animate);
  const elements = [...scope.querySelectorAll('.ms-reveal')];
  if (scope.matches?.('.ms-reveal')) elements.unshift(scope);

  elements.forEach((element) => {
    if (observed.has(element)) return;
    observed.add(element);
    if (animate) observer.observe(element);
    else element.classList.add('ms-is-visible');
  });
}

initializeMobiustreamHome();

document.addEventListener('shopify:section:load', (event) => {
  initializeMobiustreamHome(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('.ms-reveal').forEach((element) => {
    observer?.unobserve(element);
    observed.delete(element);
  });
});

motionPreference.addEventListener('change', () => {
  if (motionPreference.matches) observer?.disconnect();
  document.querySelectorAll('.ms-home').forEach((home) => {
    home.classList.toggle('ms-motion-ready', !motionPreference.matches && !isDesignMode && Boolean(observer));
    home.querySelectorAll('.ms-reveal').forEach((element) => {
      // Already visible content never needs to be hidden when the preference changes.
      element.classList.add('ms-is-visible');
    });
  });
});
